import React from "react";
import { Button, Grid, GridItem, Input, Select } from "@chakra-ui/react";
import { BsArrowCounterclockwise } from "react-icons/bs";

const RiskReviewApprovalFilters = ({ filters, onChange, onReset }) => (
  <Grid templateColumns={{ base: "1fr", lg: "minmax(260px, 2fr) 160px 160px minmax(180px, 1fr) auto" }} gap={3}>
    <GridItem>
      <Input
        placeholder="Search approvals"
        value={filters.search || ""}
        onChange={(event) => onChange({ ...filters, search: event.target.value })}
      />
    </GridItem>
    <GridItem>
      <Select value={filters.status || "PENDING"} onChange={(event) => onChange({ ...filters, status: event.target.value })}>
        <option value="PENDING">Pending</option>
        <option value="APPROVED">Approved</option>
        <option value="REJECTED">Rejected</option>
        <option value="WAITING">Waiting</option>
      </Select>
    </GridItem>
    <GridItem>
      <Input
        placeholder="Request type"
        value={filters.requestType || ""}
        onChange={(event) => onChange({ ...filters, requestType: event.target.value })}
      />
    </GridItem>
    <GridItem>
      <Input
        placeholder="Business Unit"
        value={filters.businessUnit || ""}
        onChange={(event) => onChange({ ...filters, businessUnit: event.target.value })}
      />
    </GridItem>
    <GridItem>
      <Button variant="outline" leftIcon={<BsArrowCounterclockwise />} onClick={onReset}>
        Reset
      </Button>
    </GridItem>
  </Grid>
);

export default RiskReviewApprovalFilters;
